import { pushToDataLayer } from '../datalayer';
import { EcommerceCartItem } from '../types';

export const trackRemoveFromCart = ({
  currency,
  removedItem,
  message,
}: {
  currency: string;
  removedItem?: EcommerceCartItem;
  message?: string;
}) => {
  pushToDataLayer({
    event: 'remove_from_cart',
    message,
    ecommerce: {
      currency,
      items: [removedItem],
    },
  });
};
